import type { StateDistribution } from '../../types';
import { STATE_SEGMENTS } from './constants';

// Compact stacked bar summarizing a State (1-4) distribution across a group's
// latest snapshots. Snapshot 2.0 forums report State instead of a 1-10 average.
export default function StateDistributionBar({ dist }: { dist?: StateDistribution }) {
  if (!dist || dist.total === 0) {
    return (
      <p className="text-sm text-gray-400 italic">
        No State/Direction ratings yet for this period.
      </p>
    );
  }
  return (
    <div>
      <div className="flex w-full h-3 rounded-full overflow-hidden bg-gray-100">
        {STATE_SEGMENTS.map((seg) => {
          const count = dist[seg.key];
          if (!count) return null;
          return (
            <div
              key={seg.key}
              className={seg.color}
              style={{ width: `${(count / dist.total) * 100}%` }}
              title={`${seg.label}: ${count}`}
            />
          );
        })}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-xs text-gray-600">
        {STATE_SEGMENTS.map((seg) => (
          <span key={seg.key} className="flex items-center gap-1.5">
            <span className={`inline-block w-2.5 h-2.5 rounded-full ${seg.color}`} />
            {seg.label} {dist[seg.key]}
          </span>
        ))}
      </div>
    </div>
  );
}
